import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LOGIN } from '@app/shared/constant/routes';
import { NycDoeService } from '../services/nycdoe-auth.service';

@Component({
  selector: 'app-nycdoe',
  templateUrl: './nycdoe.component.html',
  standalone: true,
  styleUrls: ['./nycdoe.component.css'],
})
export class NycdoeComponent implements OnInit {
  constructor(
    private readonly nycdoeService: NycDoeService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    if (localStorage.getItem('nycState')) {
      this.nycdoeService.isTokenValid();
    } else {
      this.router.navigate([LOGIN.URL]);
    }
  }
}
